import { PaginationMain } from "../../../../../components/common/pagination/PaginationMain";
import { PcsListElementType, PcsListMapType, PcsSearchParamType } from "../interface";
import EmptyTableRow from "../../../../common/EmptyTableRow";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import { useExportPurchaseOrders } from "../hooks/useExportPurchaseOrders";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";
import { useUser } from "../../../../../util/userContext/UserContext";

interface PropsType {
    pcs: PcsListMapType
    searchParam: PcsSearchParamType
    menuTitleText: string
    urlText: string
    isPcsDelivery?: boolean
}


export default function List({ pcs, searchParam, menuTitleText, urlText, isPcsDelivery }: PropsType) {

    const { user } = useUser();

    const { goToNavigation } = useGoToNavigation();

    const { mutate: mutateExportPurchaseOrders } = useExportPurchaseOrders()

    const btnExportExcel = () => {
        mutateExportPurchaseOrders({ ...searchParam, userId: user?.userId ?? null })
    }

    const btnCreatePcs = () => {
        goToNavigation(`${urlText}/create`, {}, false)
    }

    const btnCreateOrders = () => {
        goToNavigation(`order/orders/create`, {}, false)
    }

    const clickRow = (el: PcsListElementType) => {
        el.purchaseOrderId && goToNavigation(`${urlText}/detail/${el.purchaseOrderId}`, {}, false)
    }

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">{menuTitleText}목록(<span>{pcs.totalCount ?? 0}</span>건)</h6>
            <div className="table_toolbar">
                <button className="btn btn-dark w-150px px-0" onClick={btnExportExcel}>
                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기
                </button>
                {!isPcsDelivery && <>
                    <AuthorityChecker authorityNames={['orderWriteYn']}>
                        <button
                            className={`btn btn-primary px-0 ms-40px ${menuTitleText === "발주 " ? "w-80px" : "w-110px"}`}
                            onClick={btnCreatePcs}>{menuTitleText}{menuTitleText === "발주 " ? "신청" : "생성"}
                        </button>
                    </AuthorityChecker>
                    {menuTitleText !== "발주 " &&
                        <AuthorityChecker authorityNames={['shipmentWriteYn']}>
                            <button className="btn btn-primary px-0 w-80px"
                                onClick={btnCreateOrders}>수주 생성
                            </button>
                        </AuthorityChecker>
                    }
                </>}
            </div>
        </div>

        <div className="table_scroll">
            <table className="table table-bordered my_table">
                <colgroup>
                    {isPcsDelivery && <col style={{ width: "8%" }} />}
                    <col style={{ width: "8%" }} />
                    <col style={{ width: "8%" }} />
                    <col style={{ width: "8%" }} />
                    <col />
                    <col style={{ width: "12%" }} />
                    <col style={{ width: "8%" }} />
                    <col style={{ width: "8%" }} />
                    {isPcsDelivery && <col style={{ width: "8%" }} />}
                    <col style={{ width: "8%" }} />
                    <col style={{ width: "7%" }} />
                </colgroup>
                <thead>
                    <tr>
                        <th>발주일자</th>
                        {isPcsDelivery && <th>납품일자</th>}
                        <th>주문자</th>
                        <th>수신자</th>
                        <th>품목</th>
                        <th>규격</th>
                        <th>수량</th>
                        <th>{!isPcsDelivery ? "발송방법" : "금액"}</th>
                        {isPcsDelivery && <th>환종</th>}
                        <th>담당자</th>
                        <th>상태</th>
                    </tr>
                </thead>
                <tbody>
                    {pcs.list.length !== 0 ?
                        pcs.list.map(el => el.subjectList.map((el2, idx2) =>
                            <tr className="clickable" onClick={() => clickRow(el)}>
                                {idx2 === 0 &&
                                    <>
                                        <td className="text-center"
                                            rowSpan={el.subjectList.length}>
                                            {el.purchaseOrderDt}
                                        </td>
                                        {isPcsDelivery &&
                                            <td className="text-center"
                                                rowSpan={el.subjectList.length}>
                                                {el.newDtShipment}
                                            </td>
                                        }
                                        <td className="text-center"
                                            rowSpan={el.subjectList.length}>
                                            {el.ordererName}
                                        </td>
                                        <td className="text-center"
                                            rowSpan={el.subjectList.length}>
                                            {el.recipientName}
                                        </td>
                                    </>
                                }
                                <td className="text-center">{el2.productName}</td>
                                <td className="text-center">{el2.newTxtStandard}</td>
                                <td className="text-center"><DisplayNumber value={el2.newIQty} /></td>
                                {idx2 === 0 &&
                                    <>
                                        {!isPcsDelivery
                                            ? <td className="text-center"
                                                rowSpan={el.subjectList.length}>
                                                {el.newPShipmentName}
                                            </td>
                                            : <td className="text-center"
                                                rowSpan={el.subjectList.length}>
                                                <DisplayNumber value={el.newDAmount} />
                                            </td>
                                        }
                                        {isPcsDelivery && <td className="text-center"
                                            rowSpan={el.subjectList.length}>{el.currencyName}</td>}
                                        <td className="text-center"
                                            rowSpan={el.subjectList.length}>
                                            {el.owningUserName}
                                        </td>
                                        <td className="text-center"
                                            rowSpan={el.subjectList.length}>
                                            {el.purchaseOrderStateName}
                                        </td>
                                    </>}
                            </tr>
                        )
                        ) : <EmptyTableRow colSpan={100} />
                    }
                </tbody>
            </table>
        </div>

        <PaginationMain totalCount={pcs.totalCount ?? 0} />
    </div>
}